<template>
  <div class="vipTypeInfo">
    <img :src="details.content_img_path" class="img" alt="">
  </div>
</template>
<script>
import {vipTypeInfo} from '@/api/person'
export default {
  data() {
    return {
      details: {}
    }
  },
  mounted() {
    this.handleFun()
  },
  methods: {
    handleFun() {
      let params = {
        level_type: this.$route.query.level_type,
        level: this.$route.query.level
      }
      vipTypeInfo(params).then(res => {
        console.log(res)
        this.details = res.data
      })
    }
  }
}
</script>
<style lang="less" scoped>
.vipTypeInfo {
  width: 100vw;
  min-height: 100vh;
  background-color: #1E2020;
  padding: 20px 14px;
  box-sizing: border-box;
  .img {
    width: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/vipTypeInfo.vue